<template>
  <div class="container-fluid">
    <div class="fullscreen-mode animate__animated animate__zoomIn">
      <div class="header-fullscreen">
        <div class="header-fullscreen__logo">
          <img :src="$_config.logo.lg" alt="Logo ADHI" class="max-h-70px" />
          <img src="/static/img/logo/adhi/QHSE_720.png" alt="Logo QHSE" class="max-h-70px max-w-90px" />
        </div>
        <div class="header-fullscreen__title">
          <h1 class="mb-0 font-weight-bolder ml-3">Departemen Infrastruktur 1 <span class="d-block mt-3 font-weight-bold font-size-sm">Dashboard Periode {{ new Date | parse('month') }} Tahun {{ new Date | parse('year') }}</span>
          </h1>
        </div>
      </div>
      <div class="fullscreen-content">
        <div v-show="!isFullscreen" class="fullscreen__trigger">
          <button @click="fullScreen()" class="btn btn-primary btn-lg font-size-lg p-10">Mulai Presentasi</button>
        </div>
        <!-- <template> -->
        <carousel v-show="isFullscreen" loop autoplay :autoplayTimeout="10000" :perPage="1" :paginationEnabled="false">
          <slide>
            <div class="row">
              <div class="col-12 col-lg-9">
                <div class="card card-custom mt-3">
                  <div class="card-header border-0 pt-5 pb-0">
                    <h3 class="card-title align-items-start flex-column">
                      <span class="card-label text-primary font-weight-bolder">Penilaian Single Number Departemen</span>
                    </h3>
                  </div>
                  <div class="card-body pb-2 pt-0">
                    <div class="row">
                      <div class="col-12 align-self-center">
                        <div class="d-flex flex-column p-5">
                          <div class="row">
                            <div class="col-5 d-flex justify-content-center align-items-center">
                              <div class="text-center mb-5">
                                <span class="d-block h4 text-muted font-weight-bold">Single Number</span>
                                <span v-if="summaryData.length" :class="isRedSN" class="d-block font-weight-bolder" style="font-size: 5rem">{{ Number(summaryData.filter(x => x.name === 'single_numbers_summary')[0].prosentase).toFixed(2) }}%</span>
                                <span v-else class="d-block text-primary font-weight-bolder" style="font-size: 5rem">0%</span>
                              </div>
                            </div>
                            <div class="col-5 d-flex justify-content-center align-items-center">
                              <div class="text-center mb-5">
                                <span class="d-block h4 text-muted font-weight-bold">Target Penilaian</span>
                                <span v-if="summaryData.length && appraisalTarget" :class="Number(appraisalTarget.single_number_score).toFixed(2)>Number(summaryData.filter(x => x.name === 'single_numbers_summary')[0].prosentase).toFixed(2)? 'text-danger':'text-success' " class="d-block font-weight-bolder" style="font-size: 5rem">{{ Number(appraisalTarget.single_number_score).toFixed(2) }}%</span>
                                <span v-else class="d-block text-primary font-weight-bolder" style="font-size: 5rem">0%</span>
                              </div>
                            </div>
                            <div class="col-2">
                              <span class="d-block text-primary my-0">Pembobotan SN</span>
                              <div class="row border-bottom py-3">
                                <div class="col">SMM</div>
                                <div class="col-auto">20%</div>
                              </div>
                              <div class="row border-bottom py-3">
                                <div class="col">SMK3L</div>
                                <div class="col-auto">30%</div>
                              </div>
                              <div class="row border-bottom py-3">
                                <div class="col">QPASS</div>
                                <div class="col-auto">30%</div>
                              </div>
                              <div class="row border-bottom py-3">
                                <div class="col">5R</div>
                                <div class="col-auto">20%</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 align-self-center">
                        <div class="row">
                          <div v-for="(s,i) in summaryData.filter(x => x.name !== 'single_numbers_summary')" :key="i+'-summary-sn'" class="col-3">
                            <template v-if="s.name === 'qpass' && !s.real_data">
                              <div class="bg-light-danger text-dark-50 text-center py-10 px-5 mb-6" :class="i===0? 'mb-6': ''" style="border-radius: .42rem;">
                                <span class="text-danger font-weight-bolder" style="font-size: 2.5em;">{{ Number(s.prosentase).toFixed(2) }}%</span>
                                <span class="d-block font-weight-bold mt-5" style="font-size: 1.5rem;">{{ s.name.toUpperCase() }}</span>
                              </div>
                            </template>
                            <template v-else>
                              <div class="bg-light-primary text-dark-50 text-center py-10 px-5 mb-6" :class="i===0? 'mb-6': ''" style="border-radius: .42rem;">
                                <span class="text-primary font-weight-bolder" style="font-size: 2.5em;">{{ Number(s.prosentase).toFixed(2) }}%</span>
                                <span class="d-block font-weight-bold mt-5" style="font-size: 1.5rem;">{{ s.name.toUpperCase() }}</span>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card card-custom mt-3 card-strech">
                  <div class="card-header border-0 pt-5 pb-0">
                    <h3 class="card-title align-items-start flex-column">
                      <span class="card-label text-primary font-weight-bolder">Diagram Tren Penilaian Single Number</span>
                      <span class="text-muted mt-3 font-weight-bold font-size-sm">Penilaian Tahunan Single Number</span>
                    </h3>
                  </div>
                  <div class="card-body position-relative">
                    <apexchart :height="345" :options="trendOption" :series="trendSeries"></apexchart>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="row no-gutters">
                  <div class="col-12 col-lg-12">
                    <div class="card card-custom mt-3 card-strech no-shadow">
                      <div class="card-header border-0 pt-5 pb-0">
                        <h3 class="card-title align-items-start flex-column">
                          <span class="card-label text-primary font-weight-bolder">Klasifikasi SMM</span>
                          <span class="text-muted mt-3 font-weight-bold font-size-sm">Rekap Implementasi Penilaian SMM</span>
                        </h3>
                      </div>
                      <div class="card-body position-relative">
                        <apexchart :type="'pie'" :height="187" :options="classificationOption.mm_appraisals" :series="classificationSeries.mm_appraisals"></apexchart>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-12">
                    <div class="card card-custom mt-3 card-strech no-shadow">
                      <div class="card-header border-0 pt-5 pb-0">
                        <h3 class="card-title align-items-start flex-column">
                          <span class="card-label text-primary font-weight-bolder">Klasifikasi SMK3L</span>
                          <span class="text-muted mt-3 font-weight-bold font-size-sm">Rekap Implementasi Penilaian SMK3L</span>
                        </h3>
                      </div>
                      <div class="card-body position-relative">
                        <apexchart :type="'pie'" :height="187" :options="classificationOption.smkkkl_appraisals" :series="classificationSeries.smkkkl_appraisals"></apexchart>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-12">
                    <div class="card card-custom mt-3 card-strech no-shadow">
                      <div class="card-header border-0 pt-5 pb-0">
                        <h3 class="card-title align-items-start flex-column">
                          <span class="card-label text-primary font-weight-bolder">Klasifikasi 5R</span>
                          <span class="text-muted mt-3 font-weight-bold font-size-sm">Rekap Implementasi Penilaian 5R</span>
                        </h3>
                      </div>
                      <div class="card-body position-relative">
                        <apexchart :type="'pie'" :height="187" :options="classificationOption.r_appraisals" :series="classificationSeries.r_appraisals"></apexchart>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </slide>
          <slide>
            <div class="row">
              <div class="col-4">
                <div class="row">
                  <div class="col-12">
                    <div class="card card-custom mt-3 card-strech no-shadow">
                      <div class="card-header border-0 pt-5 pb-0">
                        <h3 class="card-title align-items-start flex-column">
                          <span class="card-label text-primary font-weight-bolder">Piramida {{ qaLabel }}</span>
                          <!-- <span class="text-muted mt-3 font-weight-bold font-size-sm">{{ labelFilter() }}</span> -->
                        </h3>
                      </div>
                      <div class="card-body position-relative">
                        <highcharts :constructorType="'chart'" :options="pyramidQA"></highcharts>
                        <!-- <div class="mt-3">
                          <table class="table v-center no-border animated">
                            <tr>
                              <th colspan="3" class="font-size-sm">Kriteria {{ qaLabel }}</th>
                            </tr>
                            <tr v-for="(c,i) in criteriaQApyramid" :key="i+'-criteria-code'">
                              <th class="font-size-sm nowrap-table"> <span :style="{'background-color': c.color}" class="color-label">&nbsp;</span> </th>
                              <th class="font-size-sm nowrap-table">{{ c.code }}</th>
                              <td class="font-size-sm">{{ c.label }}</td>
                            </tr>
                          </table>
                        </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="card card-custom mt-3 card-strech no-shadow">
                      <div class="card-header border-0 pt-5 pb-0">
                        <h3 class="card-title align-items-start flex-column">
                          <span class="card-label text-primary font-weight-bolder">Piramida {{ hseLabel }}</span>
                          <!-- <span class="text-muted mt-3 font-weight-bold font-size-sm">{{ labelFilter() }}</span> -->
                        </h3>
                      </div>
                      <div class="card-body position-relative">
                        <highcharts :constructorType="'chart'" :options="pyramidHSE"></highcharts>
                        <!-- <div class="mt-3">
                          <table class="table v-center no-border animated">
                            <tr>
                              <th colspan="3" class="font-size-sm">Kriteria {{ hseLabel }}</th>
                            </tr>
                            <tr v-for="(c,i) in criteriaHSEpyramid" :key="i+'-criteria-code'">
                              <th class="font-size-sm nowrap-table"> <span :style="{'background-color': c.color}" class="color-label">&nbsp;</span> </th>
                              <th class="font-size-sm nowrap-table">{{ c.code }}</th>
                              <td class="font-size-sm">{{ c.label }}</td>
                            </tr>
                          </table>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-8">
                <div v-if="mainData.totalBiaya" class="row">
                  <div class="col-4">
                    <div class="card card-custom mt-3">
                      <div class="card-body text-center">
                        <h4 class="m-0 font-weight-bold">Total Biaya Realisasi Penyelesaian</h4>
                        <span>(Quality Non Conformance + NC Lingkungan)</span>
                        <h1 class="text-primary font-weight-boldes mt-4 mb-0">Rp. {{ mainData.totalBiaya.filter(x => x.name === 'total_biaya_penyelesaian')[0].value.toLocaleString('id-ID') }}</h1>
                      </div>
                    </div>
                  </div>
                  <div class="col-8">
                    <div class="card card-custom mt-3">
                      <div class="card-body text-center">
                        <div class="row">
                          <div class="col-8">
                            <h4 class="m-0 font-weight-bold">{{ qaLabel }}</h4>
                            <div class="row">
                              <div class="col-6">
                                <span>Biaya Rencana</span>
                                <h1 style="color: #6c757d !important;" class="font-weight-boldes mt-4 mb-0">Rp. {{ mainData.totalBiaya.filter(x => x.name === 'total_biaya_rencana_penyelesaian')[0].value.toLocaleString('id-ID') }}</h1>
                              </div>
                              <div class="col-6">
                                <span>Realisasi Penyelesaian</span>
                                <h1 style="color: #6c757d !important;" class="font-weight-boldes mt-4 mb-0">Rp. {{ mainData.totalBiaya.filter(x => x.name === 'total_biaya_penyelesaian_nc_qa')[0].value.toLocaleString('id-ID') }}</h1>
                              </div>
                            </div>
                          </div>
                          <div class="col-4">
                            <h4 class="m-0 font-weight-bold">{{ hseLabel }}</h4>
                            <span>Biaya Realisasi Penyelesaian</span>
                            <h1 style="color: #6c757d !important;" class="font-weight-boldes mt-4 mb-0">Rp. {{ mainData.totalBiaya.filter(x => x.name === 'total_biaya_penyelesaian_nc_hse')[0].value.toLocaleString('id-ID') }}</h1>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="card card-custom mt-3 card-strech no-shadow">
                      <div class="card-header border-0 pt-5 pb-0">
                        <h3 class="card-title align-items-start flex-column">
                          <span class="card-label text-primary font-weight-bolder">Nilai Kerugian Berdasarkan Kriteria {{ qaLabel }}</span>
                          <!-- <span class="text-muted mt-3 font-weight-bold font-size-sm">{{ labelFilter() }}</span> -->
                        </h3>
                      </div>
                      <div class="card-body position-relative">
                        <apexchart height="470" :options="barKerugianOptions" :series="qaBarKerugianSeries"></apexchart>
                        <div class="mt-3">
                          <table class="table v-center no-border animated">
                            <tr>
                              <th colspan="3" class="font-size-sm">Kriteria {{ qaLabel }}</th>
                            </tr>
                            <tr v-for="(c,i) in criteriaQAbar" :key="i+'-criteria-code'">
                              <th class="font-size-sm nowrap-table"> <span :style="{'background-color': c.color}" class="color-label">&nbsp;</span> </th>
                              <th class="font-size-sm nowrap-table">{{ c.code }}</th>
                              <td class="font-size-sm">{{ c.label }}</td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="card card-custom mt-3 card-strech no-shadow">
                      <div class="card-header border-0 pt-5 pb-0">
                        <h3 class="card-title align-items-start flex-column">
                          <span class="card-label text-primary font-weight-bolder">Nilai Kerugian Berdasarkan Kriteria {{ hseLabel }}</span>
                          <!-- <span class="text-muted mt-3 font-weight-bold font-size-sm">{{ labelFilter() }}</span> -->
                        </h3>
                      </div>
                      <div class="card-body position-relative">
                        <apexchart type="bar" height="470" :options="barKerugianOptions" :series="hseBarKerugianSeries"></apexchart>
                        <div class="mt-3">
                          <table class="table v-center no-border animated">
                            <tr>
                              <th colspan="3" class="font-size-sm">Kriteria {{ hseLabel }}</th>
                            </tr>
                            <tr v-for="(c,i) in criteriaHSEbar" :key="i+'-criteria-code'">
                              <th class="font-size-sm nowrap-table"> <span :style="{'background-color': c.color}" class="color-label">&nbsp;</span> </th>
                              <th class="font-size-sm nowrap-table">{{ c.code }}</th>
                              <td class="font-size-sm">{{ c.label }}</td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </slide>
        </carousel>
        <!-- </template> -->
      </div>
      <div class="fullscreen-footer">
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
moment.locale('id')
export default {
  name: 'fullscreen-statistic',
  data () {
    return {
      config: {
        permission: {
          create: 'create-r_appraisals',
          read: 'view-r_appraisals',
          update: 'update-r_appraisals',
          delete: 'delete-r_appraisals'
        }
      },
      isFullscreen: false,
      isLoading: false,
      // Single Number
      summaryData: [],
      isRedSN: 'text-primary',
      appraisalTarget: {},
      classificationOption: {
        mm_appraisals: {
          chart: {
            type: 'pie',
            animations: {
              enabled: false
            }
          },
          plotOptions: {
            pie: {
              expandOnClick: false,
              donut: {
                labels: {
                  show: false
                }
              }
            }
          },
          dataLabels: {
            enabled: true
          },
          legend: {
            show: true,
            position: 'right',
            horizontalAlign: 'center',
            floating: false
          },
          xaxis: {
            type: 'category'
          },
          noData: {
            text: 'Loading Chart',
            align: 'center',
            verticalAlign: 'middle',
            offsetX: 0,
            offsetY: 0,
            style: {
              color: undefined,
              fontSize: '14px',
              fontFamily: undefined
            }
          },
          labels: []
        },
        r_appraisals: {
          chart: {
            type: 'pie',
            animations: {
              enabled: false
            }
          },
          plotOptions: {
            pie: {
              expandOnClick: false,
              donut: {
                labels: {
                  show: false
                }
              }
            }
          },
          dataLabels: {
            enabled: true
          },
          legend: {
            show: true,
            position: 'right',
            horizontalAlign: 'center',
            floating: false
          },
          xaxis: {
            type: 'category'
          },
          noData: {
            text: 'Loading Chart',
            align: 'center',
            verticalAlign: 'middle',
            offsetX: 0,
            offsetY: 0,
            style: {
              color: undefined,
              fontSize: '14px',
              fontFamily: undefined
            }
          },
          labels: []
        },
        smkkkl_appraisals: {
          chart: {
            type: 'pie',
            animations: {
              enabled: false
            }
          },
          plotOptions: {
            pie: {
              expandOnClick: false,
              donut: {
                labels: {
                  show: false
                }
              }
            }
          },
          dataLabels: {
            enabled: true
          },
          legend: {
            show: true,
            position: 'right',
            horizontalAlign: 'center',
            floating: false
          },
          xaxis: {
            type: 'category'
          },
          noData: {
            text: 'Loading Chart',
            align: 'center',
            verticalAlign: 'middle',
            offsetX: 0,
            offsetY: 0,
            style: {
              color: undefined,
              fontSize: '14px',
              fontFamily: undefined
            }
          },
          labels: []
        }
      },
      classificationSeries: {
        mm_appraisals: [],
        r_appraisals: [],
        smkkkl_appraisals: []
      },
      trendOption: {
        chart: {
          type: 'line',
          stacked: false,
          animations: {
            enabled: false
          },
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
              customIcons: []
            }
          }
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: false,
            columnWidth: '25%',
            endingShape: 'rounded'
          }
        },
        dataLabels: {
          enabled: true,
          enabledOnSeries: [0]
        },
        stroke: {
          width: [4, 0, 0, 0]
        },
        legend: {
          horizontalAlign: 'left',
          offsetX: 0
        },
        xaxis: {
          type: 'category'
        },
        yaxis: [
          {
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: '#008FFB'
            },
            labels: {
              style: {
                colors: '#008FFB'
              }
            },
            title: {
              text: 'Tren Penilaian Single Number',
              style: {
                color: '#008FFB'
              }
            },
            tooltip: {
              fixed: {
                enabled: true,
                position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
                offsetY: 30,
                offsetX: 60
              }
            }
          }
        ],
        noData: {
          text: 'Loading Chart',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: '14px',
            fontFamily: undefined
          }
        }
      },
      trendSeries: [],
      // NC
      mainData: {},
      qaLabel: 'QA Non Conformance',
      hseLabel: 'NC Lingkungan',
      criteriaQApyramid: [],
      criteriaHSEpyramid: [],
      pyramidHSE: {
        chart: {
          type: 'pyramid',
          spacingLeft: 50,
          spacingRight: 50,
          height: 355
        },
        title: {
          text: undefined
        },
        legend: {
          enabled: false
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          series: {
            dataLabels: {
              inside: true,
              align: 'center',
              useHTML: true,
              className: 'text-center'
            }
          }
        },
        series: [{
          data: [
            { color: '#74b945', y: 5, name: 'E<br>(30000)' },
            { color: '#5aa3e6', y: 5, name: 'D<br>(3000)' },
            { color: '#ffcf02', y: 5, name: 'C<br>(300)' },
            { color: '#a7a7a7', y: 5, name: 'B<br>(30)' },
            { color: '#ed711c', y: 5, name: 'A<br>(1)' }
          ]
        }]
      },
      pyramidQA: {
        chart: {
          type: 'pyramid',
          spacingLeft: 50,
          spacingRight: 50,
          height: 355
        },
        title: {
          text: undefined
        },
        legend: {
          enabled: false
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          series: {
            dataLabels: {
              inside: true,
              align: 'center',
              useHTML: true,
              className: 'text-center'
            }
          }
        },
        series: [{
          data: [
            { color: '#74b945', y: 5, name: 'E<br>(30000)' },
            { color: '#5aa3e6', y: 5, name: 'D<br>(3000)' },
            { color: '#ffcf02', y: 5, name: 'C<br>(300)' },
            { color: '#a7a7a7', y: 5, name: 'B<br>(30)' },
            { color: '#ed711c', y: 5, name: 'A<br>(1)' }
          ]
        }]
      },
      criteriaQAbar: [],
      criteriaHSEbar: [],
      barKerugianOptions: {
        chart: {
          height: 350,
          type: 'bar'
        },
        toolbar: {
          show: true,
          tools: {
            download: true,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
            customIcons: []
          }
        },
        colors: ['#ed711c', '#a7a7a7', '#ffcf02', '#5aa3e6', '#74b945'],
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: false,
            dataLabels: {
              position: 'top'
            },
            distributed: false
          }
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
          formatter: (value) => { return 'Rp. ' + value.toLocaleString('id-ID') },
          style: {
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 'bold',
            colors: ['#000']
          }
        },
        noData: {
          text: 'Loading Chart',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: '14px',
            fontFamily: undefined
          }
        },
        xaxis: {
          type: 'category',
          position: 'bottom'
        },
        yaxis: {
          title: {
            text: 'Rupiah'
          },
          labels: {
            formatter: (value) => { return value.toLocaleString('id-ID') }
          }
        },
        tooltip: {
          shared: true,
          intersect: false,
          marker: false,
          y: {
            formatter: (value) => { return 'Rp. ' + value.toLocaleString('id-ID') }
          },
          x: {
            formatter: (value) => { return 'Kode Kriteria: ' + value }
          }
        },
        legend: {
          show: false
        }
      },
      qaBarKerugianSeries: [{
        name: 'Nilai Kerugian',
        data: []
      }],
      hseBarKerugianSeries: [{
        name: 'Nilai Kerugian',
        data: []
      }]
    }
  },
  mounted () {
    this.loadAllData()
    window.addEventListener('keyup', o => {
      o = o || event
      if (o.shiftKey && o.keyCode === 13) {
        this.fullScreen()
      }
    })
    document.addEventListener('fullscreenchange',
      (e) => {
        var fullscreenElement = Boolean(document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement)
        this.isFullscreen = fullscreenElement
      }, false)
  },
  methods: {
    fullScreen () {
      var elem = document.documentElement
      if (elem.requestFullscreen) elem.requestFullscreen()
      else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen()
      else if (elem.msRequestFullscreen) elem.msRequestFullscreen()
    },
    exitFullScreen () {
      if (document.exitFullscreen) document.exitFullscreen()
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen()
      else if (document.msExitFullscreen) document.msExitFullscreen()
    },
    loadAllData () {
      let filter = {
        department_id: this.$route.params.id || 5,
        start_periode: moment().set('date', 1).format('YYYY-MM-DD'),
        end_periode: moment().set('date', 1).format('YYYY-MM-DD')
      }
      this.isLoading = true
      this.buildSumary(filter)
      this.buildClassification(filter)
      this.buildTrendline(filter)
      this.getTarget(filter)
      this.buildPyramidNC(filter)
      this.getTotalBiaya(filter)
      this.getBarBiayaCriteria(filter)
      this.isLoading = false
    },
    buildSumary (e) {
      // satu periode
      var filter = Object.assign({}, e)
      filter.start_periode = filter.end_periode
      this.$_api.get('custom/dashboard-single-number-summary', filter).then(res => {
        this.summaryData = res.data
        let checkItem = ['5r', 'smm', 'smk3l']
        let checkQPASS = res.data.filter(x => x.name === 'qpass')[0].real_data
        if (checkQPASS === null || checkQPASS === 0) {
          let filtered = res.data.filter(x => checkItem.includes(x.name))
          let checkNULL = filtered.map(x => !x.prosentase).filter(x => x === true)
          if (checkNULL.length === checkItem.length) this.isRedSN = 'text-danger'
          else this.isRedSN = 'text-primary'
        } else this.isRedSN = 'text-primary'
      })
    },
    buildClassification (e) {
      // satu periode
      var filter = Object.assign({}, e)
      filter.start_periode = filter.end_periode
      for (let ix = 0; ix < Object.keys(this.classificationSeries).length; ix++) {
        const el = Object.keys(this.classificationSeries)[ix]
        filter.module = el
        this.$_api.get('custom/dashboard-single-number-classification', filter).then(res => {
          this.$set(this.classificationSeries, el, res.data.map(x => Number(x.quantity)))
          this.$set(this.classificationOption, el, { labels: res.data.map(x => 'Implementasi ' + x.class) })
        })
      }
    },
    getTarget (e) {
      let filter = {
        year: moment(e.end_periode).set('date', 1).set('month', 0).format('YYYY-MM-DD'),
        limit: 1
      }
      this.$_api.dataset('single_number_target_scores', filter).then(res => {
        if (res.data.length) this.appraisalTarget = Object.assign({}, this.appraisalTarget, res.data[0])
        else {
          const def = {
            single_number_score: 0,
            smkkkl_score: 0,
            r_score: 0,
            mm_score: 0,
            qpass_score: 0
          }
          this.appraisalTarget = Object.assign({}, this.appraisalTarget, def)
        }
        this.$nextTick(() => {
          let annotate = {
            yaxis: [
              {
                y: this.appraisalTarget.single_number_score,
                strokeDashArray: 0,
                borderColor: '#00E396',
                label: {
                  borderColor: '#00E396',
                  style: {
                    color: '#fff',
                    background: '#00E396'
                  },
                  text: 'Target ' + this.appraisalTarget.single_number_score + '%'
                }
              }
            ]
          }
          this.$set(this.trendOption, 'annotations', annotate)
        })
      })
    },
    buildTrendline (e) {
      this.$_api.get('custom/dashboard-single-number-trendline', e).then(res => {
        var tmpTrend = []
        for (let index = 0; index < res.data.length; index++) {
          const each = res.data[index]
          let type = each.name === 'single_numbers_average' ? 'line' : 'bar'
          let name = each.name === 'single_numbers_average' ? 'Single Number' : each.name.toUpperCase()
          let data = each.datas.map(z => { return { x: moment(z.series_periode).format('MMM YYYY'), y: Number(z.average).toFixed(2) } })
          let mockData = each.datas.map(z => { return { x: moment(z.series_periode).format('MMM YYYY'), y: Number(z.average).toFixed(2), z: z.real_data, a: z.form_noclose_count } })
          let item = { name: name, type: type, data: data, table: mockData }
          tmpTrend.push(item)
        }
        this.trendSeries = tmpTrend
      })
    },
    buildPyramidNC (e) {
      this.$_api.get('custom/dashboard-nc-summary-pyramid', e).then(res => {
        const data = res.data
        let qaData = []
        let qaCode = []
        let color = ['#ed711c', '#a7a7a7', '#ffcf02', '#5aa3e6', '#74b945']
        for (let i = 0; i < data.nc_qa.length; i++) {
          const el = data.nc_qa[i]
          const code = { code: String.fromCharCode(96 + (i + 1)).toUpperCase(), label: el.criteria_name, id: el.id, color: color[i] }
          qaData.push({ color: color[i], y: 5, name: code.code + '<br>(' + (el.nc_count || 0) + ')' })
          qaCode.push(code)
        }
        let hseData = []
        let hseCode = []
        for (let i = 0; i < data.nc_hse.length; i++) {
          const el = data.nc_hse[i]
          const code = { code: String.fromCharCode(96 + (i + 1)).toUpperCase(), label: el.criteria_name, id: el.id, color: color[i] }
          hseData.push({ color: color[i], y: 5, name: code.code + '<br>(' + (el.nc_count || 0) + ')' })
          hseCode.push(code)
        }
        this.criteriaQApyramid = qaCode
        this.criteriaHSEpyramid = hseCode
        this.$set(this.pyramidHSE.series[0], 'data', hseData.reverse())
        this.$set(this.pyramidQA.series[0], 'data', qaData.reverse())
      }).catch(err => {
        this.$_alert.error(err)
      })
    },
    getTotalBiaya (e) {
      this.$_api.get('custom/dashboard-nc-summary-total-biaya', e).then(res => {
        this.$set(this.mainData, 'totalBiaya', res.data)
      }).catch(err => {
        this.$_alert.error(err)
      })
    },
    getBarBiayaCriteria (e) {
      this.$_api.get('custom/dashboard-nc-summary-biaya-by-criteria', e).then(res => {
        const data = res.data
        let qaData = []
        let qaRencana = []
        let qaCode = []
        let color = ['#ed711c', '#a7a7a7', '#ffcf02', '#5aa3e6', '#74b945']
        for (let i = 0; i < data.nc_qa.length; i++) {
          const el = data.nc_qa[i]
          const code = { code: String.fromCharCode(96 + (i + 1)).toUpperCase(), label: el.criteria_name, id: el.id, color: color[i] }
          qaData.push({ x: code.code, y: Number(el.biaya_penyelesaian), fillColor: color[i], strokeColor: color[i] })
          qaRencana.push({ x: code.code, y: Number(el.biaya_rencana_penyelesaian), fillColor: '#e11429', strokeColor: '#e11429' })
          qaCode.push(code)
        }
        let hseData = []
        let hseCode = []
        for (let i = 0; i < data.nc_hse.length; i++) {
          const el = data.nc_hse[i]
          const code = { code: String.fromCharCode(96 + (i + 1)).toUpperCase(), label: el.criteria_name, id: el.id, color: color[i] }
          hseData.push({ x: code.code, y: Number(el.biaya_penyelesaian), fillColor: color[i], strokeColor: color[i] })
          hseCode.push(code)
        }
        this.criteriaQAbar = qaCode
        this.criteriaHSEbar = hseCode
        this.$set(this.hseBarKerugianSeries, 0, { name: 'Nilai Kerugian', data: hseData })
        this.$set(this.qaBarKerugianSeries, 0, { name: 'Nilai Kerugian', data: qaData })
        this.$set(this.qaBarKerugianSeries, 1, { name: 'Rencana Kerugian', data: qaRencana })
      }).catch(err => {
        this.$_alert.error(err)
      })
    }
  }
}
</script>

<style scoped>
  .fullscreen-mode {
    overflow: hidden;
    display: block;
    z-index: 999999;
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #f3f6f9;
  }
  .fullscreen__trigger {
    display: flex;
    justify-content: center;
    align-items: center;
    width: calc(100vw - 4em);
    height: 90vh;
  }
  .header-fullscreen {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 2em;
  }
  .header-fullscreen__toolbar {
    margin-left: 90px;
  }
  .fullscreen-content {
    padding: 0 2em;
  }
  .color-label {
    display: block;
    width: 25px;
    height: 1.2rem;
    border-radius: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/modules/dashboard/fullscreen-statistic.vue